module.exports = __webpack_public_path__ + "1fd9ff5510fb6583361d2db3fc512560.MP3";